import { create } from "../../../../../common/utils/zustand_state_manager";
import { SetFunction, SetFunctionImpl } from "../../../../../common/utils/filters_utils";

type State = {
  IdProvisaoRecurso: number;
  tipoPesquisa: number,
  pesquisa: string | Date | number | null,

};


type Action = {
  setFilters: (filters: Partial<State>) => void;
  clearFilters: () => void;
  setTipoPesquisa: SetFunction<number>,
  setPesquisa: SetFunction<string | Date | number | null>,
};


export const initialFiltersValues: State = {
  IdProvisaoRecurso: 0,
  tipoPesquisa: 0,
  pesquisa: "",
};

export const useProvisaoRecursosFilters = create<State & Action>((set) => ({
  ...initialFiltersValues,
  setTipoPesquisa: (vfn) => SetFunctionImpl(set, 'tipoPesquisa', vfn),
  setPesquisa: (vfn) => SetFunctionImpl(set, 'pesquisa', vfn),
  setFilters: (filters) => set((state) => ({ ...state, ...filters })),
  clearFilters: () => set(initialFiltersValues),

}));